const socialMediaData = [
  {
    icon: ["fab", "google"],
    link: "mailto:rahman.sameeha@gmail.com",
    alt: "Email",
  },
  {
    icon: ["fab", "linkedin"],
    link: "https://www.linkedin.com/in/sameeha-rahman/",
    alt: "LinkedIn",
  },
  {
    icon: ["fab", "github"],
    link: "https://github.com/samsam-026",
    alt: "LinkedIn",
  },
  {
    icon: ["fab", "medium"],
    link: "https://rahman-sameeha.medium.com/",
    alt: "Medium",
  },
  {
    icon: ["fab", "twitter"],
    link: "https://twitter.com/sameeha_rahman",
    alt: "Twitter",
  },
]

export default socialMediaData
